import React, { Component } from 'react';
import styles from './Index.scss';

class Index extends Component {

  render() {
		return (
				<div className={styles.root}>
					<div className={styles.container}>
						<div className={styles.heading}>
							<h2>Sample Page</h2>
						</div>
						<div className={styles.content}>
							<p>Lorem ipsum dolor sit amet, ex eum utinam consectetuer. Veniam quaeque facilisi eam ex, at mel labitur repudiare, id erat euismod vis. Has debet inimicus no, has ne eripuit mediocrem aliquando, ei sint delenit pri. Choro convenire deterruisset nec id, evertitur reprehendunt ea nec.</p>
							<p>Volumus eligendi consequat mei in, elitr voluptua assueverit per ad, mucius philosophia vix ei. Eum ne labore gubergren reformidans, te vim verear legimus inimicus. At nec perpetua cotidieque. Ex everti aliquam mel. Est no deleniti tractatos adipiscing, at mei detraxit dissentiet. Eu audire quaeque eos, ei feugiat facilis sit, at duo mentitum offendit appareat.</p>
							<p>Eu assum eruditi consequuntur usu. Nec eu tollit labore facilisis, dicunt iudicabit philosophia eam eu. Omnesque deleniti urbanitas ad pro, congue urbanitas intellegam id nam. No exerci expetenda sea. Ex dicam verterem gubergren qui.</p>
							<p>Audire salutandi pro ne, veritus albucius ne per. Ea his simul omnes ocurreret, eu delectus partiendo persecuti eum. Case exerci utroque no per, eu vel delenit perpetua repudiare. Vim ex legere habemus, vix ne tempor detracto, ad sit veritus rationibus. Nec no regione convenire tractatos, an vide etiam voluptaria sea. Cu petentium complectitur eum.</p>
						</div>
					</div>
				</div>
		);
  }

}

export default Index;
